import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../../services/api';
import MapComponent from '../../../components/MapComponent';
import './RouteMap.css';

const RouteMapPage = () => {
    const { id: routeId } = useParams();
    const [deliveryList, setDeliveryList] = useState(null);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [userLocation, setUserLocation] = useState(null); // Состояние для текущей геолокации
    
    const navigate = useNavigate();
    const defaultCenter = [64.543013, 40.536876]; // Запасной центр, если геолокация недоступна
    const defaultZoom = 12;
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [showFilterMenu, setShowFilterMenu] = useState(false);

    // Функция для получения списка доставок
    const fetchDeliveryList = async () => {
        setIsLoading(true);
        try {
            console.log(`Fetching details for route ID: ${routeId}`);
            const response = await api.get(`/routes/${routeId}`);
            console.log('Route details fetched:', response);
            setDeliveryList(response);
            setError('');
        } catch (e) {
            const errorMessage = e.response?.message || 'Ошибка при загрузке деталей маршрутного листа';
            console.error('Error fetching route details:', e);
            setError(errorMessage);
            setDeliveryList(null);
        } finally {
            setIsLoading(false);
        }
    };

    // Получение деталей маршрута
    useEffect(() => {
        fetchDeliveryList();
    }, [routeId]);

    // Получение текущей геолокации пользователя
    // Получение текущей геолокации пользователя и отправка на сервер
    useEffect(() => {
        if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
            const coords = [position.coords.latitude, position.coords.longitude];
            setUserLocation(coords);
            // Отправляем локацию на сервер (предполагается, что api настроен для работы с auth-токеном)
            api.post('/location/location', {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            })
                .then(response => {
                console.log('Локация отправлена!:', response);
                })
                .catch(err => {
                console.error('Ошибка отправки локации!:', err);
                });
            },
            (err) => {
            console.error("Ошибка получения геолокации!:", err);
            }
        );
        } else {
        console.error("Geolocation не поддерживается вашим браузером");
        }
    }, []);
  

    const handleGoBack = () => {
        navigate(`/courier/routes/${routeId}`);
    };

    const handleRetry = () => {
        setError('');
        setDeliveryList(null);
        fetchDeliveryList();
    };

    const handleMarkerClick = (receiptId) => {
        if (receiptId) {
            navigate(`/courier/receipts/${receiptId}`);
        }
    };

    if (isLoading) {
        return (
            <div className="route-map-page loading">
                Загрузка деталей маршрутного листа...
            </div>
        );
    }

    if (error) {
        return (
            <div className="route-map-page error">
                <p>{error}</p>
                <button onClick={handleRetry}>Попробовать снова</button>
            </div>
        );
    }

    return (
        <div className="route-map-page">
            {deliveryList && (
                <div style={{ height: '100%', width: '100%' }}>
                    <MapComponent
                        // Если геолокация получена, используем её как центр, иначе - стандартный центр
                        center={userLocation || defaultCenter}
                        zoom={defaultZoom}
                        receipts={deliveryList.receipts}
                        onMarkerClick={handleMarkerClick}
                        userLocation={userLocation} // Передаем координаты пользователя в MapComponent
                    />
                </div>
            )}
        </div>
    );
};

export default RouteMapPage;
